import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { appVersion } from "../services/constants";
import { loginApi, loginMemberStackApi } from "../Api";
import { useAuth } from "../Router"; // Adjust the path if necessary
// Import Memberstack
import { MemberstackProvider, useMemberstack } from "@memberstack/react";

// Setup Memberstack keys
const memberstackConfig = {
  publicKey: "pk_b3d30192cc0bae7dfb0d",
  secretKey: "sk_e23b5baa724e3fa72fa4",
};

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { login } = useAuth(); // Get the login function from context
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const checkEmailExists = async (email) => {
    try {
      const response = await fetch("https://api-k8s.engiv.io/checkemail", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();
      return data.exists;
    } catch (error) {
      console.error("Error checking email:", error);
      return false;
    }
  };

  const MemberstackContent = () => {
    const memberstack = useMemberstack(); // Move useMemberstack hook inside MemberstackContent

    const handleLogin = async () => {
      setIsLoading(true);
      try {
        const emailExists = await checkEmailExists(username);
        if (!emailExists) {
          setError("Can’t find an account with that email. Check for typos or sign up instead.");
          setIsLoading(false);
          return;
        }

        const response = await memberstack.loginMemberEmailPassword({
          email: username,
          password: password,
        });

        if (response.data && response.data.member && response.data.member.id) {
          const memberStackResponse = await loginMemberStackApi(
            response.data.member.id
          );
          if (memberStackResponse) {
            login();
            navigate("/");
          }
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };

    const handleForgotPassword = () => {
      memberstack
        .openModal("FORGOT_PASSWORD", { planId: "PLAN_ID" })
        .then((signupData) => {
          console.log("User signed up!", signupData);
          memberstack.hideModal();
        });
    };

    return (
      <>
        <button
          className="secondary-button"
          onClick={handleLogin}
          disabled={isLoading}
        >
          {isLoading ? "Please wait..." : "Login"}
        </button>
        <div>
          <a href="#" onClick={handleForgotPassword}>Forgot Password?</a>
          <div className="separator"></div>
          <p>
            New here? <a href="/onboarding">Create your account</a>
          </p>
        </div>
      </>
    );
  };

  return (
    <MemberstackProvider config={memberstackConfig}>
      <div className="login-container">
        <div className="login">
          <h2>Welcome Back</h2>
          <h3>Sign in to continue where you left off</h3>
          <div>
            <label htmlFor="email">Email</label>
            <input
              type="text"
              placeholder="You@example.com"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div>
            <label htmlFor="password">Password</label>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="********"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              id="password"
            />
            <span
              onClick={togglePasswordVisibility}
              style={{
                position: "absolute",
                right: "10px",
                top: "45%",
                cursor: "pointer",
              }}
            >
              <i
                className={
                  showPassword ? "ico-hide-password" : "ico-show-password"
                }
              ></i>
            </span>
          </div>
          {error && <p className="error-message">{error}</p>}
          <MemberstackContent />
        </div>
        <p className="app-version">
          <b>{appVersion}</b>
        </p>
      </div>
    </MemberstackProvider>
  );
};

export default Login;
